import { RoleNames } from '@smorder/logic';

const allowedRoles = [RoleNames.Admin, RoleNames.Reports, RoleNames.ReportsAdvanced];

export default allowedRoles;
